import { useQuery } from '@tanstack/react-query';
import { useOkapiKy } from '@folio/stripes/core';

export default function useReportTypesAPI() {
  const okapiKy = useOkapiKy();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['report-types'],
    queryFn: async () => {
      const response = await okapiKy.get('report-types?query=isActive==true&limit=100').json();
      return response;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
  });

  return {
    reportTypes: data?.reportTypes || [],
    totalRecords: data?.totalRecords || 0,
    isLoading,
    error,
    refetch
  };
}
